module.exports = __webpack_public_path__ + "img/709f39e67eb846e5bcb3bdc7c921d3cd-1440.381e65a2.jpg";